import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DeliveryConsignmentListService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { DeliveryConsignmentListService };
